import { Stack, TableCell, TableRow } from "@mui/material";
import { types } from "api";
import { StyledButton } from "components/StyledButton";
import { Link } from "react-router-dom";
import { getPath, routes } from "routes";

export interface StudentTableRowProps {
	row: types.User;
}

// const PREFIX = "GroupTableRow";

export const StudentTableRow = ({ row }: StudentTableRowProps): JSX.Element => {
	return (
		<TableRow hover role="checkbox" key={row.userId}>
			<TableCell data-testid="firstName">
				<Stack direction="row" alignItems="center">
					{row.firstName}
				</Stack>
			</TableCell>
			<TableCell data-testid="lastName">{row.lastName}</TableCell>
			<TableCell data-testid="email">{row.email}</TableCell>
			<TableCell data-testid="yearLevel">{row.yearLevel}</TableCell>
			<TableCell data-testid="edit-action">
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.metrics._.viewMetrics, { userId: row.userId })}
				>
					VIEW METRICS
				</StyledButton>
			</TableCell>
		</TableRow>
	);
};
